import React from 'react'
import TagsFilter from './TagsFilter'
import { toggleSelection } from '../utils/helpers'
import { translations, articleTypeLabels } from '../data/translations'

const ArticleFilters = ({
  filtersOpen,
  setFiltersOpen,
  selectedTypes,
  setSelectedTypes,
  language,
}) => {
  const t = translations[language]

  return (
    <div className="filters">
      <button
        className="filters__toggle"
        onClick={() => setFiltersOpen(!filtersOpen)}
      >
        <span className="filters__toggle-text">{t.filters.filtersTitle}</span>
        <div className={`filters__toggle-icon ${filtersOpen ? 'open' : ''}`} />
      </button>
      <div className={`filters__content ${filtersOpen ? 'active' : ''}`}>
        <div className="filters__wrapper">
          <TagsFilter
            title={t.filters.tags}
            tags={[
              'News',
              'Guide',
              'Preview',
              'Patch',
              'OTA',
              'Opinion',
              'Season',
              'Spotlight',
              'QA',
              'Mode',
              'SeriesDrop',
              'Other',
            ]}
            selected={selectedTypes}
            onToggle={(tag) =>
              toggleSelection(selectedTypes, tag, setSelectedTypes)
            }
            language={language}
            articleTypeLabels={articleTypeLabels}
          />
        </div>
      </div>
    </div>
  )
}

export default ArticleFilters
